import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/home';

export default function HeroSlider() {
  const [current, setCurrent] = useState(0);
  const total = heroSlides.length;

  const goTo = useCallback((index: number) => {
    setCurrent(((index % total) + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % total);
    }, 5000);
    return () => clearInterval(timer);
  }, [total]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
            index === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
        </div>
      ))}

      <div className="relative z-20 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className={`transition-all duration-500 ${
          heroSlides.map((_, i) => i === current ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 hidden')
        }`}>
          <h2 className="text-2xl md:text-5xl font-heading font-bold text-white text-center mb-3 md:mb-5 drop-shadow-lg">
            {heroSlides[current].title}
          </h2>
          <p className="text-sm md:text-lg text-white/85 text-center max-w-2xl mx-auto mb-6 md:mb-8 drop-shadow">
            {heroSlides[current].subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to={heroSlides[current].link}
              className="whitespace-nowrap px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm md:text-base transition-all cursor-pointer"
            >
              立即观看
            </Link>
            <Link
              to="/category/anime"
              className="whitespace-nowrap px-8 py-3 bg-white/15 hover:bg-white/25 text-white border border-white/30 rounded-full font-medium text-sm md:text-base transition-all cursor-pointer backdrop-blur-sm"
            >
              浏览全集
            </Link>
          </div>
        </div>

        <div className="absolute bottom-6 md:bottom-8 flex items-center gap-2">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => goTo(index)}
              className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                index === current
                  ? 'bg-primary-500 w-8'
                  : 'bg-white/50 hover:bg-white/80'
              }`}
              aria-label={`第${index + 1}张`}
            ></button>
          ))}
        </div>

        <button
          onClick={() => goTo(current - 1)}
          className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/30 text-white transition-all cursor-pointer backdrop-blur-sm"
          aria-label="上一张"
        >
          <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
        </button>
        <button
          onClick={() => goTo(current + 1)}
          className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/15 hover:bg-white/30 text-white transition-all cursor-pointer backdrop-blur-sm"
          aria-label="下一张"
        >
          <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
        </button>
      </div>
    </section>
  );
}